
import Choice from 'choices.js';
export default class Select {

    static get selector() {
      return '.styleSelect';
    }
    
    constructor(el) {
        this.select = el;
        this.style = this.select.dataset.style;
        new Choice(this.select, {
            searchEnabled : false,
            placeholder: true,
            shouldSort: false,
            allowHTML: true,
            itemSelectText: this.select.dataset.itemSelect,
            classNames: {
                containerOuter: 'choices' + ' ' + this.style,
            }
        });

        this.select.removeAttribute('hidden');
        this.select.classList.add('selectHidden');
    }

   

}
